
import { defineComponent, PropType } from 'vue'
interface IInformation {
    title: string
    infosList: [text: string, img: string]
}

/**
 * Componente contendo as informações sobre o produto
 * @props {Object<IInformation>} infos - Objecto do tipo IInformation contendo
 * todas as informações do produto.
 */
export default defineComponent({
    props: {
        infos: {
            type: Object as PropType<IInformation>,
            required: true,
        },
    },
})
